import io from 'socket.io-client';
import { BASE_HOST } from './api.js';

class WebSocketService {
  constructor() {
    this.socket = null;
    this.alertCallback = null;
  }

  connect(serverUrl = BASE_HOST) {
    this.socket = io(serverUrl, {
      transports: ['websocket', 'polling']
    });

    this.socket.on('connect', () => {
      console.log('Conectado al servidor WebSocket');
    });

    this.socket.on('disconnect', () => {
      console.log('Desconectado del servidor WebSocket');
    });

    this.socket.on('alert', (data) => {
      console.log('Alerta recibida:', data);
      if (this.alertCallback) {
        this.alertCallback(data);
      }
    });

    this.socket.on('connect_error', (error) => {
      console.error('Error de conexión WebSocket:', error);
    });
  }

  setAlertCallback(callback) {
    this.alertCallback = callback;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

export default new WebSocketService(); 